import { useState, useEffect } from 'react';
import { getCookie, setCookie } from '../utils/cookies.js';
import { d as COOKIE_FIRST_VISIT_NAME } from '../cookies-l-jEMp6P.js';
import 'cookies-next';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-a4IKjS7g.js';
import '../utils/isBot.js';

const useFirstVisit = () => {
    const [isFirstVisitModalOpened, setIsFirstVisitModalOpened] = useState(false);
    const handleClose = () => {
        const consentCookie = getCookie('CookieConsent');
        if (consentCookie) {
            const oneMonthFromNow = new Date();
            oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);
            setCookie(COOKIE_FIRST_VISIT_NAME, 'no', { expires: oneMonthFromNow });
        }
        else {
            setCookie(COOKIE_FIRST_VISIT_NAME, 'no');
        }
        setIsFirstVisitModalOpened(false);
    };
    useEffect(() => {
        const isFirstVisit = getCookie(COOKIE_FIRST_VISIT_NAME) !== 'no';
        setIsFirstVisitModalOpened(isFirstVisit);
        if (isFirstVisit) {
            setIsFirstVisitModalOpened(true);
            setCookie(COOKIE_FIRST_VISIT_NAME, 'no');
        }
    }, []);
    return { isFirstVisitModalOpened, setIsFirstVisitModalOpened, handleClose };
};

export { useFirstVisit as default };
//# sourceMappingURL=useFirstVisit.js.map
